const getcreateUpdateProcurementLocationReq = {
  locationId: 0,
  locationName: '',
  countryCode: '',
  countryName: '',
  stateCode: '',
  stateName: '',
  cityName: '',
  postalCode: '',
  portId: '',
  portCode: '',
  portName: '',
  portType: '',
  actionMode: true,
  isLocked: true,
  isChecked: true,
  totalRows: 0,
  currentTr: '',
};
export default getcreateUpdateProcurementLocationReq;
